import client from "./client";

const teacherLogsApi = {
  list(params = {}) {
    return client.get("/teacher-logs", { params }).then((r) => r.data);
  },

  create(body) {
    return client.post("/teacher-logs", body).then((r) => r.data);
  },

  approve(id, body = {}) {
    return client.patch(`/teacher-logs/${id}/approve`, body).then((r) => r.data);
  },

  reject(id, body) {
    return client.patch(`/teacher-logs/${id}/reject`, body).then((r) => r.data);
  },

  comment(id, body) {
    return client.patch(`/teacher-logs/${id}/comment`, body).then((r) => r.data);
  },

  update(id, body) {
    return client.patch(`/teacher-logs/${id}`, body).then((r) => r.data);
  },

  delete(id) {
    return client.delete(`/teacher-logs/${id}`).then((r) => r.data);
  },

  getMissing(params = {}) {
    return client.get("/teacher-logs/missing", { params }).then((r) => r.data);
  },

  exportCsv(params = {}) {
    return client.get("/teacher-logs/export", { params, responseType: "blob" }).then((r) => r.data);
  },
};

export default teacherLogsApi;
